import { ReactComponent as Logo } from "../images/site-logo.svg";

export function Header() {
    return (
        <div className="header" data-testid="header">
            <Logo />
        </div>
    );
}
